import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconPaperPlane: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="paper-plane, send"><path d="M2.67061 4.38253C2.31845 3.32605 3.41942 2.37118 4.41548 2.86921L20.4414 10.8822C21.3627 11.3428 21.3627 12.6576 20.4414 13.1182L4.41548 21.1312C3.41941 21.6292 2.31845 20.6743 2.67061 19.6179L4.9599 12.75H9.25041C9.66462 12.75 10.0004 12.4142 10.0004 12C10.0004 11.5858 9.66462 11.25 9.25041 11.25H4.95976L2.67061 4.38253Z" fill="currentColor"/></CentralIconBase>;
};

export default IconPaperPlane;
